var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.50001C12.7143 4.53938 15.4121 3.02766 21.2857 3.00001C21.3796 2.99963 21.4727 3.01878 21.5595 3.05634C21.6463 3.0939 21.7252 3.14913 21.7916 3.21885C21.858 3.28856 21.9106 3.37139 21.9463 3.46255C21.9821 3.55372 22.0004 3.65141 22 3.75001V17.25C22 17.4489 21.9247 17.6397 21.7908 17.7803C21.6568 17.921 21.4752 18 21.2857 18C15.5714 18 13.3638 19.2098 12 21M12 7.50001C11.2857 4.53938 8.58795 3.02766 2.71429 3.00001C2.62039 2.99963 2.52735 3.01878 2.44053 3.05634C2.35371 3.0939 2.27482 3.14913 2.20842 3.21885C2.14203 3.28856 2.08943 3.37139 2.05366 3.46255C2.01788 3.55372 1.99965 3.65141 2.00001 3.75001V17.1595C2.00001 17.6227 2.27322 18 2.71429 18C8.42857 18 10.6442 19.2188 12 21M12 7.50001V21",
    stroke: "#3545DE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.8a61535e27f527edc645a3b8656d6ffd.svg";
export { ForwardRef as ReactComponent };